export default __webpack_public_path__ + "assets/images/2e3e652daba3badcd7edb1d1d50d4499.png";